<template>
    <a-modal title="My Payroll"
             :visible="visible"
             width="90%"
             @ok="close"
             @cancel="close"
             style="top: 20px;">
        <a-row :gutter="[16,16]">
            <a-col :span="24">
                <g-select label="Año a Consultar"
                          :options="years"
                          style="width: 100%;"
                          :formItemConfig="fiConfig"
                          :selectConfig="slConfig"
                          :selectedObj.sync="yearSelected"
                ></g-select>
            </a-col>
        </a-row>
        <a-row>
            <a-tabs defaultActiveKey="1" v-if="isYearSelected">
                <a-tab-pane tab="Resumen" key="1">
                    <a-spin :spinning="resumeChart.chartLoading">
                        <a-card style="min-height: 400px">
                            <canvas id="resumen" width="400" height="400"></canvas>
                        </a-card>
                    </a-spin>
                </a-tab-pane>
                <a-tab-pane tab="Detalles" key="2">
                    <g-datatable :endpoint="masterSetup.endpoint"
                                 :columns="masterSetup.tableSetup.columns"
                                 :tableConfig="masterSetup.tableSetup.tableConfig"
                                 :requestData="masterRequestData"
                                 :customSlots="masterSetup.tableSetup.customSlots"
                                 ref="masterComp">
                        <div slot="nominaRender" slot-scope="{record, text}" style="text-align: right;">
                            <span style="color: green;"
                                  v-if="record.coc_natu === 'DEV'">{{format(parseInt(text))}}</span>
                            <span style="color: red;" v-if="record.coc_natu === 'DED'">{{format(parseInt(text))}}</span>
                            <span style="color: blue;"
                                  v-if="record.coc_natu === 'NXP'">{{format(parseInt(text))}}</span>
                        </div>
                    </g-datatable>
                </a-tab-pane>
            </a-tabs>
            <span v-else>Seleccione un año para consultar.</span>
        </a-row>
    </a-modal>
</template>
<script>
  import NumberUtils from '@/util/NumberUtils'
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Chart from 'chart.js'

  export default {
    data () {
      return {
        years: [],
        yearSelected: {},
        resumeChart: {
          chartLoading: false,
          resumenData: {},
          chart: {}
        },
        fiConfig: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': false,
          style: 'margin-bottom: 0px;'
        },
        slConfig: {
          style: 'width: 100%',
          showSearch: true
        },
        masterSetup: {
          endpoint: 'ss/dashboard/tu_nomina',
          tableSetup: {
            columns: [
              {title: 'Item', dataIndex: 'coc_name', sorter: true, fixed: 'left'},
              {
                title: 'Enero',
                dataIndex: 'enero',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Febrero',
                dataIndex: 'febrero',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Marzo',
                dataIndex: 'marzo',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Abril',
                dataIndex: 'abril',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Mayo',
                dataIndex: 'mayo',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Junio',
                dataIndex: 'junio',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Julio',
                dataIndex: 'julio',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Agosto',
                dataIndex: 'agosto',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Septiembre',
                dataIndex: 'septiembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Octubre',
                dataIndex: 'octubre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Noviembre',
                dataIndex: 'noviembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Diciembre',
                dataIndex: 'diciembre',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {
                title: 'Total',
                dataIndex: 'total',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'nominaRender'
                }
              },
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true}
            ],
            tableConfig: {
              rowKey: 'rowid',
              pagination: {
                pageSize: 40,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40']
              }
            },
            customSlots: ['nominaRender']
          }
        }
      }
    },
    props: ['visible'],
    mounted () {
      this.httpClient = new HttpUtil()
      let year = moment().year()
      for (let i = year; i >= year - 4; i--) {
        this.years.push({
          value: i, text: i
        })
      }
    },
    methods: {
      format (value) {
        if (value < 0) {
          return '-' + NumberUtils.formatMoney(Math.abs(value), 0)
        }
        return NumberUtils.formatMoney(value, 0)
      },
      close () {
        this.$emit('ok')
      },
      loadResumeData () {
        this.resumeChart.chartLoading = true
        this.httpClient.getInstance().get('ss/dashboard/tu_nomina/resumen',
          {
            params: {
              year: this.yearSelected.value
            }
          })
          .then(response => {
            if (JsUtils.isEmpty(this.resumeChart.chart)) {
              this.initResumeChart(response.data)
            } else {
              this.updateResumeChart(response.data)
            }
            this.resumeChart.chartLoading = false
          })
      },
      initResumeChart (barChartData) {
        this.resumeChart.resumenData = barChartData

        this.resumeChart.chart = new Chart('resumen', {
          type: 'line',
          data: this.resumeChart.resumenData,
          options: {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: 'Resumen de Calificación'
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: true
                }
              }],
              yAxes: [{
                gridLines: {
                  display: true
                }
              }]
            },
            tooltips: {
              enabled: true,
              callbacks: {
                label: (tooltipItem, data) => {
                  let label = data.datasets[tooltipItem.datasetIndex].label || ''

                  if (label) {
                    label += ': '
                  }
                  label += this.format(tooltipItem.yLabel)
                  return label
                }
              }
            }
          }
        })
      },
      updateResumeChart (barChartData) {
        this.resumeChart.resumenData.datasets.splice(0, this.resumeChart.resumenData.datasets.length)
        this.resumeChart.resumenData.labels.splice(0, this.resumeChart.resumenData.labels.length)
        barChartData.labels.map(label => {
          this.resumeChart.resumenData.labels.push(label)
        })
        barChartData.datasets.map(dataset => {
          this.resumeChart.resumenData.datasets.push(dataset)
        })
        this.resumeChart.chart.update()
      }
    },
    watch: {
      yearSelected () {
        this.loadResumeData()
      }
    },
    computed: {
      isYearSelected () {
        return !JsUtils.isEmpty(this.yearSelected)
      },
      masterRequestData () {
        return {year: this.yearSelected.value}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/MyPayroll.vue